export default __webpack_public_path__ + "static/media/Cannabis Start-up.92f62a2a.pdf";